<template>
	<div class="package-div container-fluid d-flex flex-row" v-if="showPack">
		<!-- <transition name="first-slide" :duration="500"  > -->
		<transition
			name="slideLeft"
			enter-active-class="fadeDown" leave-active-class="fadeUp"
			:duration="20"
			appear 
			>
			<div id="box1" v-if="!modalShow">
				
				<b-row class="packages-detail" no-gutters>
					<template v-for="(item, key) in packages">
						<b-col :key="key" cols="12">
							<div v-if="item.id === 8&&showeHotDeals" class="hot-deals-package">
								<b-form-checkbox
									:id="item.id.toString()"
									:checked="checkValue(item.id)"
									:disabled="checkDisabled(item.id)"
									@change="onchangePackage($event, item.id, key)"
								>
									<div
										v-if="!item.information"
										class="feature-box cursor-pointer d-flex flex-row justify-content-center align-items-center align-self-center
"
										:class="[
											item.background_color,
											{
												'disabled-package': checkDisabled(item.id)
											}
										]"
									>
										{{ $t(item.packages_details[0].package_detail_locales[0].name) }}
									</div>
									<div
										class="package-discription "
										:class="{
											'cursor-pointer': !checkDisabled(item.id)
										}"
									>
										{{ $t(item.packages_details[0].package_detail_locales[0].package_description) }}
									</div>
								</b-form-checkbox>
								<div class="d-block d-md-none pack-description">
									{{ $t(item.packages_details[0].package_detail_locales[0].package_description) }}
								</div>
							</div>
							
							<!-- First big one -->
							<div v-else-if="item.id === 7" class="big-package">
								<h5 >{{ $t('makeAdsInteresting') }}</h5>
								<b-form-checkbox
									:id="item.id.toString()"
									:checked="checkValue(item.id)"
									:disabled="checkDisabled(item.id)"
									@change="handleModalOpening"
								>
									<div
										class="d-flex flex-column cursor-pointer"
										:class="{
											'disabled-package': checkDisabled(item.id)
										}"
										:style="
											!checkedPakages[7].packagesDetails
												? { padding: 'auto' }
												: null
										"
										style="width:100%;"
									>
										<b-row class="justify-content-between align-items-center m-0">
											<b-col class="d-flex align-items-center cols "  style="padding-left: 0;padding:0">
												<!-- LOGO -->
												<div class="green-back" :style="{width:isMobile?'100%':'',}">
													<b-img src="@/assets/logo_w.png" fluid :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
												</div>
												<!-- DESCRIPTION -->
												<div class="package-discription">
													{{ $t(item.description_property) }}
												</div>
											</b-col>
											<!-- PRICE -->
											<div class="big-price text-center" 
												:style="{width:isMobile?'100%':'','margin-top':isMobile?'10px':''}">
												<div v-if="checkedPakages[7].packagesDetails">
													<span class="mr-2"
														>{{ checkedPakages[7].packagesDetails.price }}
														{{ $t('baht') }}</span
													>
													<span class="editBtn" @click="handleModalOpening"
														><EditIcon
													/></span>
												</div>
												<span v-else>
													{{$t(checkPlaceholder(item.packages_details, item))}}
												</span>
											</div>
										</b-row>
										<b-row
											v-if="checkedPakages[7].packagesDetails"
											class="packDetailsRow mt-1"
										>
											<div class="d-flex align-items-center">
												<span class="packDetails">{{$t('discountList.dialog.startDate')}} 08 : 00 {{$t('hr')}}.</span>
											</div>
											<div>
												<span class="packDetails"
													>{{$t('packages.date')}} {{ displayedPreBookedDates[0].day }}/{{
														displayedPreBookedDates[0].month
													}}/{{ displayedPreBookedDates[0].year }}
												</span>
												<span
													v-if="checkedPakages[7].packagesDetails.id !== 11"
													class="packDetails"
												>
													-
													{{ displayedPreBookedDates[1].day }}/{{
														displayedPreBookedDates[1].month
													}}/{{ displayedPreBookedDates[1].year }}
												</span>
											</div>
											<div class="text-center d-flex align-items-center">
												<span class="packDetails"
													>{{$t('packages.for a time')}}
													{{ checkedPakages[7].packagesDetails.num_days }} {{$t('days')}}</span
												>
												
											</div>
										</b-row>
									</div>
								</b-form-checkbox>
								<div class="d-block d-md-none pack-description">
									{{ $t(item.description_property) }}
								</div>
								
							</div>
							<!-- Normal packages -->
							<div v-if="item.id !== 8&&item.id !== 7" class="wrap-package">
								<b-form-checkbox
									:class="[
										{
											'disabled-package': checkDisabled(item.id)
										}
									]"
									:id="item.id.toString()"
									:checked="checkValue(item.id)"
									:disabled="checkDisabled(item.id)"
									@change="onchangePackage($event, item.id, key)"
								>
									<div
										v-if="!item.information"
										class="feature-box cursor-pointer"
										:class="[
										item.background_color
										]"
									>
										{{ $t(item.name) }}
									</div>
									<div
										v-else
										id="website-package"
										class="website-url-listing-box feature-box cursor-pointer"
										:class="{
											'disabled-package': checkedPakages[item.id].disabled
										}"
									>
										{{ $t(item.name) }}
										<InformationOutlineIcone />
									</div>
									<b-tooltip
										v-if="item.information"
										target="website-package"
										placement="righttop"
										custom-class="website-tool-tips"
									>
										<div v-html="$t(item.information)"></div>
									</b-tooltip>
									<div
										class="package-discription "
										:class="{
											'cursor-pointer': !checkDisabled(item.id)
										}"
									>
										{{ $t(item.description_property) }}
									</div>
								</b-form-checkbox>

								<v-select
									class="select-package"
									:class="{ 'no-cursor': checkDisabled(item.id) }"
									v-model="checkedPakages[item.id].packagesDetails"
									:options="item.packages_details"
									:disabled="checkDisabled(item.id)"
									:placeholder="$t(checkPlaceholder(item.packages_details, item))"
									@input="handlePackageDetails($event, key)"
								>
									<template #selected-option="{ num_days, price }">
										<div style="display: flex; align-items: baseline;">
											{{ num_days }}{{ $t('days') }} - {{ price }}{{ $t('baht') }}
										</div>
									</template>
									<template v-slot:option="option" style="color: #626262;">
										{{ option.num_days }}{{ $t('days') }} - {{ option.price }}{{ $t('baht') }}
									</template>
								</v-select>
								<div class="package-discription2">{{ $t(item.description_property) }} </div>
							</div>
						</b-col>
					</template>
					<b-col v-if="checkedPakages[6].value === true" cols="12">
						<div class="form-group d-flex flex-row justify-content-start align-items-center ml-4">
							<label style="margin-bottom:0;">{{ $t('packages.website.url.label') }}</label>
							<div class="input-div ml-3" style="width: 83%;">
								<b-input
									type="url"
									placeholder="https://marketplace.khaosod.co.th"
									class="input-search form-control"
									v-model="websiteUrl"
									pattern="https?://.*"
									v-on:blur="checkWebsiteUrl($event.target.value)"
									style="height:40px;"
								/>
							</div>
						</div>
					</b-col>
				</b-row>
				<div class="note notes">
					<h5>{{ $t('packages.interestingTrick') }}</h5>
					<div>{{ $t('packages.promotionDescription') }}</div>
				</div>
			</div>
		</transition>
		<!-- </transition>

        <transition name="second-slide" :duration="500"   > -->
		<transition
			name="slideRight"
			enter-active-class="fadeDown" leave-active-class="fadeUp"
			:duration="20"
			appear 
			>
			<div id="box2" v-if="modalShow" >
				<!-- MODAL -->
				<template v-for="(item, key) in packages" >
								<div :key="key"
									id="modal-big-package"
									class="big-package-modal big-package-modal-body d-flex flex-column justify-content-center align-items-center"
									v-if="item.id === 7"
									
								>
									<span>{{$t('packages.to make your announcement stand out')}}</span>
									<p>{{$t('packages.We therefore limit the area to only 5 announcements per day')}}
										
									</p>
									<p>{{$t('packages.Your announcement will be placed on the Thairath website at the time')}}
										
										<span class="semiBold">08 : 00 {{$t('hr')}}.</span>
									</p>
									<v-select
										class="select-package modal-select mb-3"
										v-model="checkedPakages[7].packagesDetails"
										:options="item.packages_details"
										:placeholder="$t(checkPlaceholder(item.packages_details, item))"
										@input="fetchPreBookingDates($event)"
									>
										<template #selected-option="{ num_days, price }">
											<div>{{ num_days }}{{$t('days')}} - {{ price }}{{ $t('baht') }}</div>
										</template>
										<template v-slot:option="option">
											{{ option.num_days }}{{$t('days')}} - {{ option.price }}{{ $t('baht') }}
										</template>
									</v-select>
									<p v-if="!checkedPakages[7].packagesDetails">
										{{$t('packages.please select')}}
									</p>
									<p v-else-if="datesFetched">
										<span
											>{{$t('packages.date')}} {{ displayedPreBookedDates[0].day }}/{{
												displayedPreBookedDates[0].month
											}}/{{ displayedPreBookedDates[0].year }}</span
										>
										<span v-if="checkedPakages[7].packagesDetails.id !== 11">
											- {{$t('packages.date')}} {{ displayedPreBookedDates[1].day }}/{{
												displayedPreBookedDates[1].month
											}}/{{ displayedPreBookedDates[1].year }}</span
										>
									</p>
									<p v-else>
										<b-spinner
											variant="'primary'"
											style="width: 23px; height: 23px;"
											label="Spinning"
										></b-spinner>
									</p>
									<p>{{$t('userDashboard.paymentHistory.fieldsPayment.amount')}}
										
										<span v-if="checkedPakages[7].packagesDetails">{{
											checkedPakages[7].packagesDetails.price
										}}</span>
										<span v-else>...</span> {{$t('baht')}}
									</p>
									<div class="big-package-modal-footer justify-content-center">
										<b-button
											class="big-packages-modal-btn"
											variant="danger"
											pill
											@click="cancel()"
											>{{$t('specialDeal.cancel')}}</b-button
										>
										<b-button class="big-packages-modal-btn ml-5" pill @click="okay()" :class="!datesFetched?'disabled-button':''"
											>{{$t('bill.save')}}</b-button
										>
									</div>
								</div>
				</template>
			</div>
		</transition>
		<!-- </transition> -->
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
// Icons
import InformationOutlineIcone from 'vue-material-design-icons/InformationOutline.vue';
import EditIcon from '@/components/icons/IconEdit/index';
import moment from 'moment';
import $ from 'jquery';
export default {
	name: 'Packages',
	components: {
		InformationOutlineIcone,
		EditIcon
	},
	data() {
		return {
			previousPackDetails: null,
			datesFetched: false,
			preBookedDates: [],
			displayedPreBookedDates: [
				{
					day: null,
					month: null,
					year: null
				},
				{
					day: null,
					month: null,
					year: null
				}
			],
			modalShow: false,
			showPack: false,
			checkedPakages: {},
			websiteUrl: null,
			urlIsValid: false
		};
	},
	props: {
		showeHotDeals:{
			type:Boolean,
			required:false,
			default:true
		},
		userPayment: {
			type: Array,
			default: () => {
				return [];
			}
		},
		website: {
			type: String,
			default: null
		}
	},
	computed: {
		...mapGetters("UserController", ["isLogin", "isMobile", "isTablet"]),
		...mapState('PackageController', ['packages', 'userListingPackage'])
	},
	created() {
		this.$root.loading=true;
		this.GET_PACKAGES({
			take: 10,
			page: 1
		}).then(result => {
			
			// Set reactive property for packages
			this.packages.forEach(el => {
				this.$set(this.checkedPakages, el.id, {
					value: false,
					disabled: false,
					packagesDetails: null,
					isBought: false
				});
			});
			if (
				this.$route.name === 'EditListing' ||
				this.$route.name === 'UserPackageScreen'
			) {
				// Check pack in payment process
				Object.values(this.userPayment).forEach(payment => {
					payment.user_payments_details.forEach(pack => {
						const packId = pack.packages_detail.package_id;
						this.checkedPakages[packId].value = true;
						this.checkedPakages[packId].packagesDetails = {
							id: pack.packages_detail.id,
							num_days: pack.packages_detail.num_days,
							package_id: pack.packages_detail.package_id,
							price: pack.packages_detail.price
						};
						if (packId === 1) {
							this.togglePackages(2, true);
							this.togglePackages(5, true);
						}
						if (packId === 7) {
							this.fetchPreBookingDates(this.checkedPakages[7].packagesDetails);
							this.togglePackages(1, true);
							this.togglePackages(2, true);
							this.togglePackages(5, true);
						}
					});
				});
				// Get the bought packs
				this.GET_USER_LISTING_PACKAGE(this.$route.params.id).then(res => {
					this.$root.loading=false;
					// disable/check the already bought packs
					this.userListingPackage.forEach(id => {
						const packId = id.toString();
						this.togglePackages(packId, true);
						this.checkedPakages[packId].isBought = true;
						if (id === 1) {
							this.togglePackages(2, true);
							this.togglePackages(5, true);
						}
						if (id === 7) {
							this.togglePackages(1, true);
							this.togglePackages(2, true);
							this.togglePackages(5, true);
						}
					});
					// Show packages
					this.showPack = true;
				});
			} else {
				// Show packages
				this.showPack = true;
				this.$root.loading=false;
			}

			// Fill the website if exist
			if (this.website) {
				this.websiteUrl = this.website;
			}
		});
	},
	watch:{
		modalShow(val){
			console.log("val",val)
			if(val){
				$('.footer').hide();
				$('#box2').toggleClass('animate','slow');
				$("#box1").toggleClass('animate','slow');
			}else{
				$('.footer').show();
				$("#box1").toggleClass('animate','slow');
				$('#box2').toggleClass('animate','slow');
			}
		}
	},
	methods: {
		...mapActions('PackageController', [
			'GET_PACKAGES',
			'GET_USER_LISTING_PACKAGE'
		]),
		...mapActions('PaymentController', ['GET_PREBOOKING_DATES']),

		// BIG-PACK MODAL
		async handleModalOpening(val) {
			if (!val) {
				this.handleModalCancel();
				return;
			}
			this.modalShow = true;
			// Fetch dates if pack is already selected
			if (this.checkedPakages[7].packagesDetails) {
				// Save pack details if user click on backdrop before confirm
				this.previousPackDetails = this.checkedPakages[7].packagesDetails;
				this.fetchPreBookingDates(this.checkedPakages[7].packagesDetails);
			}
			// wait for the modal response to check or uncheck the pack
			await this.$nextTick();
			this.checkedPakages[7].value = val;
		},
		fetchPreBookingDates(ev) {
			this.datesFetched = false;

			const params = {
				packDetailsId: ev.id
			};
			if (
				this.$route.name === 'EditListing' ||
				this.$route.name === 'UserPackageScreen'
			) {
				params.packId = parseInt(this.$route.params.id);
			}
			this.GET_PREBOOKING_DATES(params).then(res => {
				this.preBookedDates = res.prebooked_dates;
				this.datesFetched = true;
				// First Day
				this.formatDate(
					new moment(res.prebooked_dates[0].show_date).local('th'),
					0
				);
				// Last Day
				if (this.checkedPakages[7].packagesDetails.id !== 11) {
					const lastDay = new moment(
						res.prebooked_dates[res.prebooked_dates.length - 1].show_date
					).local('th');
					this.formatDate(lastDay, 1);
				} else {
					this.resetPreBookingDates(1);
				}
			});
		},
		formatDateOutput(date) {
			if (date < 10) {
				return `0${date}`;
			} else {
				return date;
			}
		},
		formatDate(date, id) {
			this.displayedPreBookedDates[id].day = this.formatDateOutput(date.date());
			this.displayedPreBookedDates[id].month = this.formatDateOutput(
				date.month() + 1
			);
			this.displayedPreBookedDates[id].year = date.year();
		},
		resetPreBookingDates(id) {
			this.displayedPreBookedDates[id].day = null;
			this.displayedPreBookedDates[id].month = null;
			this.displayedPreBookedDates[id].year = null;
		},
		handleModalCancel() {
			this.checkedPakages[7].value = false;
			this.checkedPakages[7].packagesDetails = null;
			this.resetPreBookingDates(0);
			this.resetPreBookingDates(1);
			this.previousPackDetails = null;
			if (
				!this.checkedPakages[1].isBought &&
				// prevent the uncheck of checked 2 & 5 pack if no confirmation of the khaosod pack
				!(
					(this.checkedPakages[2].value && !this.checkedPakages[2].disabled) ||
					(this.checkedPakages[5].value && !this.checkedPakages[5].disabled)
				)
			) {
				this.togglePackages(1, false);
				this.togglePackages(2, false);
				this.togglePackages(5, false);
			}

			this.modalShow = false;
			this.preBookedDates = [];
			this.selected();
		},
		handleModalConfirm() {
			if (!this.checkedPakages[7].packagesDetails) {
				this.handleModalCancel();
				return;
			}
			this.checkedPakages[7].value = true;

			this.togglePackages(1, true);
			this.togglePackages(2, true);
			this.togglePackages(5, true);

			this.modalShow = false;
			this.selected();
		},
		okay(){
			this.datesFetched = false
			// Click Confirm
			this.handleModalConfirm();
		},
		cancel(){
			this.datesFetched = false
			this.handleModalCancel();
		},
		// handleModalHide(ev) {
		// 	if (ev.trigger === 'ok') {
		// 		// Click Confirm
		// 		this.handleModalConfirm();
		// 	} else if (
		// 		// Click Cancel or backdrop before confirm
		// 		ev.trigger === 'cancel' ||
		// 		(ev.trigger === 'backdrop' &&
		// 			this.checkedPakages[7].value &&
		// 			!this.previousPackDetails)
		// 	) {
		// 		this.handleModalCancel();
		// 	} else if (
		// 		// Click backdrop after confirm
		// 		ev.trigger === 'backdrop' &&
		// 		this.checkedPakages[7].packagesDetails
		// 	) {
		// 		// put back previously selected pack details
		// 		this.checkedPakages[7].packagesDetails = this.previousPackDetails;
		// 		this.checkedPakages[7].value = true;
		// 	}
		// },
		// URL INPUT
		checkWebsiteUrl(val) {
			if (val) {
				if (val.match('https://') || val.match('http://')) {
					this.urlIsValid = false;
					this.selected();
					return;
				} else {
					
					this.urlIsValid = true;
					this.selected();
					return this.$bvToast.toast(this.$t('packages.Please check your website url'), {
						title: `Error!`,
						variant: 'danger',
						solid: true
					});
				}
			} else {
				this.urlIsValid = true;
				this.selected();
			}
		},
		// COM TO PARENT
		selected() {
			this.checkedPakages[6].value
				? !this.websiteUrl
					? (this.urlIsValid = true)
					: (this.urlIsValid = false)
				: (this.urlIsValid = false);
			this.$emit('childToParent', {
				packagesValue: this.checkedPakages,
				websiteUrl: this.websiteUrl,
				disabled: this.urlIsValid,
				preBookedDates: this.preBookedDates
			});
		},
		// V-SELECT
		handlePackageDetails(ev, index) {
			this.checkedPakages[ev.package_id].packagesDetails = ev;
			this.onchangePackage(true, ev.package_id, index);
		},
		checkPlaceholder(packages_details, pack) {
			if (
				this.checkedPakages[pack.id].packagesDetails === null &&
				(pack.id === 2 || pack.id === 5) &&
				this.checkedPakages[1].value
			) {
				return this.$t('included in the package');
			} else if (pack.id === 7) {
				return this.$t('packages.khaosod.placeholder');
			} else {
				return this.$t('display duration');
			}
		},
		// CHECKBOX
		checkValue(id) {
			// If already bought stay checked
			if (this.checkedPakages[id].isBought) {
				return true;
			} else {
				return this.checkedPakages[id].value;
			}
		},
		checkDisabled(id) {
			// If already bought stay disabled
			if (this.checkedPakages[id].isBought||this.checkedPakages[id].disabled) {
				return true;
			} else {
				return this.checkedPakages[id].disabled;
			}
		},
		// Check & disable pack
		togglePackages(id, val) {
			this.checkedPakages[id].value = val;
			this.checkedPakages[id].disabled = val;
			// Reset the pack details
			this.checkedPakages[id].packagesDetails = null;
		},
		onchangePackage(isChecked, id, index) {
			this.checkedPakages[id].value = isChecked;
			// Select the first pack details as default if not selected yet
			if (!this.checkedPakages[id].packagesDetails) {
				this.checkedPakages[id].packagesDetails = this.packages[index].packages_details[0];
			}
			// remove pack details if unchecking
			if (!isChecked) {
				this.checkedPakages[id].packagesDetails = null;
			}
			// Check & disable pack 2 and 5 if pack 1 is selected
			if (id === 1 && isChecked === true) {
				this.togglePackages(2, true);
				this.togglePackages(5, true);
			} else if (id === 1) {
				this.togglePackages(2, false);
				this.togglePackages(5, false);
			}

			this.selected();
		}
	}
};
</script>

<style lang="scss">
@import 'packages.scss';
</style>
